/**
 * Whether the kitchen display currently has a live socket.
 *
 * Read by the order queries to decide how hard to poll: the socket already
 * pushes every change, so polling on top of it is a safety net, not the engine.
 */
import { useSyncExternalStore } from "react";
import { isKitchenWsConnected, subscribeKitchenWsStatus } from "../lib/ws-status";

export function useKitchenWsConnected(): boolean {
  return useSyncExternalStore(
    subscribeKitchenWsStatus,
    isKitchenWsConnected,
    // Server render / first paint: assume no socket, so a display that opens
    // on a broken connection starts at the quick interval rather than the slow
    // one.
    () => false,
  );
}
